<template>
  <v-container fluid>
    <LoadingModal :is-loading="isLoading" custom-text="Идет загрузка"/>

    <v-row>
      <div class='header'>
        <h2>Состояние сервера.</h2>
      </div>

      <div class='horizontal-rule' />

      <v-container v-if="failedToLoad || !serverStatus">
        <h2>Не удалось загрузить данные о сервере.</h2>
        <h3>Попробуйте обновить страницу.</h3>
      </v-container>

      <v-container v-if="!failedToLoad && serverStatus">
        <v-row>
          <p>(Данные актуальны на {{ currentDate }}. Для получения актуальных данных, необходимо обновить страницу)</p>
        </v-row>

        <v-row>
          <v-progress-linear
              :color="calculateColor(100 - freeMainDiskPercentage)"
              :value="100 - freeMainDiskPercentage"
              height="20"
              class="my-4"
          >
            <div>
              <strong>Память диска с системой:</strong> {{ freeMainDiskPercentage }}% доступно ({{ freeMainDiskAsString() }})
            </div>
          </v-progress-linear>
        </v-row>

        <v-row>
          <v-progress-linear
              :color="calculateColor(100 - freeMediaDiskPercentage)"
              :value="100 - freeMediaDiskPercentage"
              height="20"
              class="my-4"
          >
            <div>
              <strong>Память диска для фото:</strong> {{ freeMediaDiskPercentage }}% доступно ({{ freeMediaDiskAsString() }})
            </div>
          </v-progress-linear>
        </v-row>

        <v-row>
          <v-progress-linear
              :color="calculateColor(100 - freeRamPercentage)"
              :value="100 - freeRamPercentage"
              height="20"
              class="my-4"
          >
            <div>
              <strong>Оперативная память:</strong> {{ freeRamPercentage }}% доступно ({{ freeRamAsString() }})
            </div>
          </v-progress-linear>
        </v-row>

        <v-row>
          <v-progress-linear
              :color="calculateColor(cpuLoadPercentage)"
              :value="cpuLoadPercentage"
              height="20"
              class="my-4"
          >
            <div>
              <strong>Загрузка процессора:</strong> {{ cpuLoadPercentage }}%
            </div>
          </v-progress-linear>
        </v-row>

      </v-container>

    </v-row>

  </v-container>
</template>

<script>
import { fetchServerStatus } from "@/services/serverStatusAPI";
import LoadingModal from "@/components/UI/LoadingModal";

export default {
  name: 'ServerStatusPage',

  components: {LoadingModal},

  data() {
    return {
      serverStatus: null,
      isLoading: false,
      failedToLoad: false,
    }
  },

  methods: {
    calculateColor(percentage) {
      if (percentage > 75) return 'red';
      if (percentage > 50) return 'orange';
      if (percentage > 25) return 'yellow';
      return 'green';
    },
    convertBytes(bytes) {
      const kilobytes = bytes / 1024;
      const megabytes = kilobytes / 1024
      const gigabytes = megabytes / 1024

      if (gigabytes > 1) {
        return gigabytes.toFixed(2) + ' GB';
      }

      if (megabytes > 1) {
        return megabytes.toFixed(2) + ' MB';
      }

      return bytes + ' bytes';
    },
    freeRamAsString() {
      return this.convertBytes(this.serverStatus.ramInfo.available);
    },
    freeMainDiskAsString() {
      return this.convertBytes(this.serverStatus.mainDiskInfo.available);
    },
    freeMediaDiskAsString() {
      return this.convertBytes(this.serverStatus.mediaDiskInfo.available);
    }
  },

  computed: {
    isAdmin() {
      return this.$store.getters.getIsViewAdminPanel;
    },
    freeRamPercentage() {
      return ((this.serverStatus.ramInfo.available / this.serverStatus.ramInfo.total) * 100).toFixed(2);
    },
    freeMainDiskPercentage() {
      return ((this.serverStatus.mainDiskInfo.available / this.serverStatus.mainDiskInfo.total) * 100).toFixed(2);
    },
    freeMediaDiskPercentage() {
      return ((this.serverStatus.mediaDiskInfo.available / this.serverStatus.mediaDiskInfo.total) * 100).toFixed(2);
    },
    cpuLoadPercentage() {
      return (this.serverStatus.processorInfo.cpuLoad).toFixed(2);
    },
    currentDate() {
      const date = new Date();
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();

      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    }
  },

  async mounted() {
    this.isLoading = true
    await fetchServerStatus()
        .then((data) => {
          this.serverStatus = data.result;
        })
        .catch((e) => {
          if (e.response.status === 404) this.failedToLoad = true
        })
        .finally(() => {
          this.isLoading = false
        })
  },

  watch: {
    async page() {
      this.isLoading = true
      await fetchServerStatus()
          .then((data) => {
            this.serverStatus = data;
          })
          .catch((e) => {
            if (e.response.status === 404) this.failedToLoad = true
          })
          .finally(() => {
            this.isLoading = false
          })
    }
  }
};
</script>

<style scoped>

</style>